import type { FrontDoorApp } from '@omni/front-door'
import { FileText, Landmark, LayoutGrid, Leaf, NotebookPen, Scale, Trees, Users, type LucideIcon } from 'lucide-react'

// Small helpers for the launcher: the person's name for the greeting and
// the menu, the time of day, and an icon per app.

/** "pedro.arroyo@nateva.co.nz" -> "Pedro Arroyo". */
function nameFromEmail(email: string | null | undefined): string | null {
  const local = email?.split('@')[0]
  if (!local) return null
  const parts = local.split(/[._-]+/).filter((p) => /^[a-z]+$/i.test(p))
  if (parts.length === 0) return null
  return parts.map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()).join(' ')
}

/** The person's full name: the access list's display name, else read from their email. */
export function personName(displayName: string | null | undefined, email: string | null | undefined): string | null {
  return displayName?.trim() || nameFromEmail(email)
}

export function firstName(full: string | null): string | null {
  return full?.split(/\s+/)[0] || null
}

export function initials(full: string | null, email: string | null | undefined): string {
  const src = full ?? email ?? ''
  const words = src.split(/[\s@._-]+/).filter(Boolean)
  return ((words[0]?.[0] ?? '') + (full ? (words[1]?.[0] ?? '') : '')).toUpperCase() || '·'
}

export function timeOfDay(now = new Date()): string {
  const h = now.getHours()
  return h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening'
}

const ICONS: Record<string, LucideIcon> = {
  field: NotebookPen,
  partners: Users,
  agreements: Scale,
  yield: Trees,
  carbon: Leaf,
  finance: Landmark,
  reports: FileText,
}

export function appIcon(app: Pick<FrontDoorApp, 'slug'>): LucideIcon {
  return ICONS[app.slug] ?? LayoutGrid
}
